// extracted by mini-css-extract-plugin
export var backupIcon = "_tg-1";
export var image = "_tg-0";